export default __webpack_public_path__ + "static/bellabeat-8e57e75e7ad7c59b5f23d228c685746b.png";